import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type UserState =
  | "AGENCY"
  | "INITIAL"
  | "INVALID_COUNTRY"
  | "LOGGED_OUT"
  | "NEW_CONTACT_FOR_ACCOUNT"
  | "POST_LEAD"
  | "PRE_LEAD"
  | "SQUARE_ONLY"
  | "SQUARE_AND_MOP"
  | "SQUARESPACE"
  | "MAROPOST"
  | "THANK_YOU"
  | "WAIT_FOR_EMAIL"
  | "WRONG_ACCOUNT"
  | "MAINTENANCE_MODE";

const initialState = {
  email: "",
  userState: "INITIAL" as UserState,
};

export const userStateSlice = createSlice({
  name: "userState",
  initialState,
  reducers: {
    setEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload;
    },
    setUserState: (state, action: PayloadAction<UserState>) => {
      state.userState = action.payload;
    },
  },
});

export const userActions = userStateSlice.actions;
